import type { FC } from "react"
import "./styles.css"

interface SkiIconProps {
  className?: string
  fill?: string
  width?: number
  height?: number
  "aria-label"?: string
  role?: string
}

export const SkiIcon: FC<SkiIconProps> = ({ className, fill, width, height, "aria-label": ariaLabel, role }) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    width={width || "19"}
    height={height || "17"}
    viewBox="0 0 19 17"
    fill={fill ? fill : "#BAFD4F"}
    aria-label={ariaLabel}
    role={role}
  >
    <path d="M16.0286 3.49C16.8405 3.49 17.4986 2.83186 17.4986 2.02C17.4986 1.20814 16.8405 0.550003 16.0286 0.550003C15.2167 0.550003 14.5586 1.20814 14.5586 2.02C14.5586 2.83186 15.2167 3.49 16.0286 3.49Z" />
    <path d="M18.0789 15.61L16.4889 16.55C16.3889 16.6 16.2889 16.63 16.1789 16.63C16.1089 16.63 16.0489 16.63 15.9889 16.6L0.768939 11.41C0.448939 11.3 0.278939 10.96 0.388939 10.64C0.498939 10.32 0.838939 10.16 1.15894 10.26L7.68894 12.49C7.68894 12.49 7.76894 12.41 7.80894 12.37L11.0589 9.79001L8.43894 7.83C8.43894 7.83 8.38894 7.79 8.35894 7.76C8.22894 7.64 8.10894 7.5 8.01894 7.33C7.93894 7.19 7.88894 7.04 7.85894 6.88L10.8689 7.63L12.8589 9.12001C13.0589 9.27001 13.1789 9.5 13.1789 9.75C13.1789 10 13.0689 10.24 12.8789 10.39L9.47894 13.09L16.1089 15.35L17.4689 14.55C17.7589 14.38 18.1289 14.48 18.2989 14.76C18.4689 15.05 18.3689 15.42 18.0889 15.59L18.0789 15.61Z" />
    <path d="M17.32 8.60001L13.7 8.83001C13.7 8.83001 13.67 8.83001 13.65 8.83001C13.44 8.83001 13.23 8.75001 13.08 8.59001C12.92 8.42001 12.83 8.20001 12.85 7.97001L12.98 6.05001L12.74 6.18001L8.25 5.07001C8.37 4.94001 8.51 4.83001 8.67 4.74001L12.33 2.73001C13.11 2.30001 14.09 2.59001 14.52 3.37001C14.65 3.62001 14.72 3.88001 14.72 4.14001C14.72 4.16001 14.72 4.18001 14.72 4.20001V4.30001L14.52 7.16001L17.22 6.99001C17.66 6.96001 18.05 7.30001 18.08 7.74001C18.11 8.18001 17.77 8.57001 17.33 8.60001H17.32Z" />
    <path d="M17.2583 8.43C17.2583 8.43 17.1983 8.43 17.1683 8.42L4.65833 5.42C4.43833 5.37 4.30833 5.15 4.35833 4.93C4.40833 4.71 4.62833 4.58 4.84833 4.63L17.3583 7.63C17.5783 7.68 17.7083 7.9 17.6583 8.12C17.6183 8.3 17.4483 8.43 17.2683 8.43H17.2583Z" />
  </svg>
)
